import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from "react-i18next";

// import config from "config/config.js";

// react component for creating dynamic tables
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CheckIcon from "@material-ui/icons/Check";
//
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//
import AddItemCustom from "componentsCustom/AddItem/AddItemCustom.js";

import {
  priceTotal,
  calculateValueCurrency
} from "util/calculation.js";

// import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

const styles = {
  closeSweetAlertStyle: {
    position: "absolute",
    top: 10,
    right: 10,
    backgroundColor: "white"
  },
  backSweetAlertStyle: {
    position: "absolute",
    top: 10,
    left: 10,
    backgroundColor: "white"
  },
  forwardIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0
  },
  acceptIcon: {
    position: "absolute",
    top: 0,
    right: 0
  }
};

const useStyles = makeStyles(menuStyle);

export default function AddItem(props) {
  const {
    language,
    currency,
    showAlert,
    alert,
    title,
    description,
    onConfirm,
    onCancel,
    showCancel,
    selectItem,
    price,
    hasRemoveIngredients,
    hasAddItem,
    customIngredients,
    customStyle,
    hasNote
  } = props;

  const classes = useStyles();

  const { t } = useTranslation();

  const [quantity, setQuantity] = useState(1);

  const [note, setNote] = useState("");

  const [ingredientC, setIngredientC] = useState({});
  const [list, setList] = useState([]);

  const [detailList, setDetailList] = useState({});
  const [showDetail, setShowDetail] = useState(false);

  const [date, setDate] = useState(detailList.date || "");

  // console.log("SELECT ITEM", { selectItem });

  useEffect(() => {
    if (
      selectItem &&
      selectItem._id &&
      selectItem._id.ingredients &&
      Array.isArray(selectItem._id.ingredients) &&
      selectItem._id.ingredients.length > 0 &&
      selectItem.removableIngredients &&
      hasRemoveIngredients
    ) {
      let copyIngredients = [].concat(selectItem._id.ingredients);

      copyIngredients = selectItem.removableIngredients.map(el => {
        const findEl = selectItem._id.ingredients.find(name => name._id === el);
        if (findEl) {
          return {
            ...findEl,
            price: 0,
            quantity: 1
          };
        }
        return null;
      });
      copyIngredients.filter(Boolean);
      // THIS FILTER SHOULD BE USELESS BUT
      // "the prudence is never too much"
      const removeItem = {
        _id: "REMOVE",
        type: "REMOVE",
        method: "multi-select",
        isRequired: false,
        title: t("menuList.remove_title"),
        title_it: t("menuList.remove_title"),
        title_en: t("menuList.remove_title"),
        maxNumber: null,
        add: copyIngredients
      };
      let list = [].concat([removeItem]);
      if (hasAddItem && customIngredients && customIngredients.length >= 0) {
        let copyCustomIngredients = [].concat(customIngredients);
        copyCustomIngredients = customIngredients.map(el => {
          const copyEl = Object.assign({}, el);
          copyEl.maxNumber = el.maxNumber || null;
          return copyEl;
        });
        list = [].concat([removeItem]).concat(copyCustomIngredients);
      }
      setList(list);
    } else if (
      hasAddItem &&
      customIngredients &&
      customIngredients.length >= 0
    ) {
      setList(customIngredients);
    }
  }, [selectItem, customIngredients, hasAddItem, hasRemoveIngredients, t]);

  let totalPrice = priceTotal(
    [
      Object.assign({}, selectItem, {
        price,
        quantity,
        ingredientC
      })
    ],
    currency
  );

  let totPrice =
    totalPrice && !Number.isNaN(Number(totalPrice))
      ? Number(totalPrice).toFixed(2)
      : "0.00";

  let isSize = false;

  if (totPrice === "0.00" && (!price || price === 0 || price === "0")) {
    if (customIngredients && customIngredients.length >= 0) {
      // const findElSize = dish.add.find((el) => el.type === 'SIZE')
      const findElSize = customIngredients.find(el => el.type === "SIZE");
      if (findElSize) {
        const nums = findElSize.add.map(el => el.price);
        let minValue = Math.min.apply(Math, nums);
        if (Number.isNaN(Number(minValue))) {
          minValue = 0;
        }

        totPrice = `${t("from")} ${calculateValueCurrency(
          Number(minValue),
          currency
        ).toFixed(2)}`;
        isSize = true;
      }
    }
  }

  function updateQuantity(type) {
    let copyQuantity = quantity;
    if (type === "minus") {
      copyQuantity -= 1;
    } else {
      copyQuantity += 1;
    }
    setQuantity(copyQuantity);
  }

  const confirmClass = classNames({
    [classes.buttonAlert]: true,
    [classes.totalButton]: true
  });

  function onCancelFunction() {
    setShowDetail(false);
    setDetailList([]);
    setQuantity(1);
    setIngredientC({});
    setNote("");
    onCancel();
    setDate("");
  }

  function onConfirmFunction() {
    const copyDate = date;
    setShowDetail(false);
    setDetailList([]);
    setQuantity(1);
    setIngredientC({});
    setNote("");
    setDate("");
    // console.log("ITEM IS NUOVO", {
    //   selectItem: Object.assign({}, selectItem, { date: date }),
    //   quantity,
    //   ingredientC,
    //   note,
    //   prova: Math.round(quantityHg * 100)
    // });

    onConfirm(
      Object.assign({}, selectItem, { date: copyDate }),
      quantity,
      ingredientC,
      note
    );
  }

  function isDisabled() {
    const isEveryOptional = currentValue => !currentValue.isRequired;

    if (hasAddItem) {
      if (customIngredients && customIngredients.every(isEveryOptional)) {
        // ALL CUSTOM INGREDIENTS ARE OPTIONAL
        return false;
      } else {
        // ONE OR MORE INGREDIENT ARE REQUIRED
        // FOUND ALL REQUIRED ITEM
        const filterRequired = customIngredients.filter(el => el.isRequired);

        let isAlreadySelect = false;
        filterRequired.forEach((item, i) => {
          if (item && item.type === "date") {
            if (!date) {
              isAlreadySelect = true;
            }
          } else if (ingredientC && ingredientC[`${item.type}_${item._id}`]) {
            if (ingredientC[`${item.type}_${item._id}`].length <= 0) {
              isAlreadySelect = true;
            }
            // CHECK IF ALL REQUIRED ITEM ARE SELECTED
          } else {
            isAlreadySelect = true;
          }
          // isAlreadySelect = ingredientC[
          //   `${detailList.type}_${detailList._id}`
          // ].findIndex(ing => ing._id === el._id);
        });
        return isAlreadySelect;
      }
    }
    return false;
  }

  function addDate(date) {
    const copyIngredientC = { ...ingredientC };

    copyIngredientC[`${detailList.type}_${date}`] = [];
    let copyIngredientId = JSON.parse(
      JSON.stringify(copyIngredientC[`${detailList.type}_${date}`] || [])
    );
    copyIngredientId.push({ label_it: date, label_en: date, _id: date });
    copyIngredientC[`${detailList.type}_${date}`] = copyIngredientId;
    setIngredientC(copyIngredientC);
    setDate(date);
  }

  function addIngredientsButton(
    el,
    method,
    operator,
    maxNumber,
    hasChangeQuantity = false
  ) {
    const copyIngredientC = { ...ingredientC };

    let copyIngredientId = JSON.parse(
      JSON.stringify(
        copyIngredientC[`${detailList.type}_${detailList._id}`] || []
      )
    );
    let ingFind = -1;
    if (ingredientC && ingredientC[`${detailList.type}_${detailList._id}`]) {
      ingFind = ingredientC[`${detailList.type}_${detailList._id}`].findIndex(
        ing => `${ing._id}_${ing.label_it}` === `${el._id}_${el.label_it}`
      );
    }
    if (!hasChangeQuantity) {
      if (ingFind >= 0) {
        copyIngredientId.splice(ingFind, 1);
      } else {
        // IF THE ELEMENT IS NOT FOUND

        if (
          maxNumber &&
          copyIngredientId &&
          copyIngredientId.length >= maxNumber
        ) {
          /* */
          // console.log("");
        } else {
          const copyEl = Object.assign({}, el, {
            quantity: 1,
            price: el.price || 0
          });

          if (method === "select") {
            copyIngredientId = [copyEl];
          } else {
            // MULTI SELECT FOR ADD INGREDIENTS
            copyIngredientId.push(copyEl);
          }
        }
      }

      copyIngredientC[
        `${detailList.type}_${detailList._id}`
      ] = copyIngredientId;
      setIngredientC(copyIngredientC);
    } else {
      // by type plus or minus
      if (ingFind >= 0) {
        const copyIng = JSON.parse(
          JSON.stringify(
            ingredientC[`${detailList.type}_${detailList._id}`][ingFind]
          )
        );
        if (method === "select") {
          // HO GIA UN ELEMENTO E CAMBIO LA QUANTITA'
          if (operator === "plus") {
            copyIng.quantity += 1;
            copyIngredientId = [copyIng];
            // copyIngredientC[`${detailList.type}_${detailList._id}`] = copyIng;
            // setIngredientC(copyIngredientC);
          } else {
            if (copyIng.quantity === 1) {
              // devo toglierlo dall'ARRAY
              copyIngredientId.splice(ingFind, 1);
            } else {
              copyIng.quantity -= 1;
              copyIngredientId = [copyIng];
            }
          }
          copyIngredientC[
            `${detailList.type}_${detailList._id}`
          ] = copyIngredientId;
          setIngredientC(copyIngredientC);
        } else {
          if (operator === "plus") {
            copyIng.quantity += 1;

            copyIngredientId[ingFind] = copyIng;
            // setIngredientC(copyIngredientC);
          } else {
            if (copyIng.quantity === 1) {
              // devo toglierlo dall'ARRAY
              copyIngredientId.splice(ingFind, 1);
            } else {
              copyIng.quantity -= 1;
              copyIngredientId.splice(ingFind, 1, copyIng);
            }
          }
          copyIngredientC[
            `${detailList.type}_${detailList._id}`
          ] = copyIngredientId;
          setIngredientC(copyIngredientC);
        }
      } else {
        // NON HO TROVATO L'ELEMENTO
        if (method === "select") {
          if (operator === "plus") {
            const copyEl = Object.assign({}, el, {
              quantity: 1,
              price: el.price || 0
            });
            copyIngredientId = [copyEl];

            copyIngredientC[
              `${detailList.type}_${detailList._id}`
            ] = copyIngredientId;
            setIngredientC(copyIngredientC);
          } else {
            if (el.quantity) {
              // TOGLI l'ELEMNTO
            }
            // NON FARE NIENTE
          }
        } else {
          if (operator === "plus") {
            const copyEl = Object.assign({}, el, {
              quantity: 1,
              price: el.price || 0
            });
            copyIngredientId.push(copyEl);

            copyIngredientC[
              `${detailList.type}_${detailList._id}`
            ] = copyIngredientId;
            setIngredientC(copyIngredientC);
          }
        }
      }
    }
  }

  return (
    <>
      {showAlert ? (
        <SweetAlert
          success={alert.success}
          danger={alert.danger}
          customClass={classes.containerAlert}
          style={{
            padding: 0
          }}
          title={""}
          onConfirm={onConfirmFunction}
          onCancel={onCancelFunction}
          // cancelBtnCssClass={`${classes.buttonAlert}`}
          // confirmBtnCssClass={`${confirmClass}`}
          // cancelBtnText={t("menuList.cancel_button").toUpperCase()}
          // confirmBtnText={`${t("cart.add_to_cart").toUpperCase()}`}
          showCancel={false}
          showConfirm={false}
        >
          <>
            <div
              style={{
                height: "40px"
              }}
            ></div>
            {/* {selectItem.image ? (
              <img
                alt={`image-${
                  selectItem && selectItem._id && selectItem._id._id
                    ? selectItem._id._id
                    : "select"
                }`}
                src={
                  selectItem.image ||
                  "https://cdn.foodiestrip.com/restaurant_image/58c6cce4d6cc5a36f06a8c68/images/600x600/trattoria-molo-sud-trattoria-san-benedetto-del-tronto1535130997086.jpeg"
                }
                className={classes.imageAlert}
                // togliere width all'immagine per non farla quadrata e slabbrata
              />
            ) : (
              <div
                style={{
                  height: "50px"
                }}
              ></div>
            )} */}
            <Button
              round
              size="sm"
              color="transparent"
              className={classes.buttonSmall}
              style={Object.assign({}, styles.closeSweetAlertStyle, {
                borderColor: customStyle.buttonAction
              })}
              onClick={onCancelFunction}
            >
              <span className={classes.buttonText} style={{ fontSize: "11px" }}>
                <CloseIcon
                  style={{ marginRight: 0, color: customStyle.buttonAction }}
                />
              </span>
            </Button>
            {showDetail ? (
              <Button
                round
                size="sm"
                color="transparent"
                className={classes.buttonSmall}
                style={Object.assign({}, styles.backSweetAlertStyle, {
                  borderColor: customStyle.buttonAction
                })}
                onClick={() => {
                  setShowDetail(false);
                  setDetailList([]);
                }}
              >
                <span
                  className={classes.buttonText}
                  style={{ fontSize: "11px", paddingLeft: "6px" }}
                >
                  <ArrowBackIosIcon
                    style={{ marginRight: 0, color: customStyle.buttonAction }}
                  />
                </span>
              </Button>
            ) : null}
          </>
          <div className={classes.containerAlertBody}>
            <div className={classes.dishName}>{title}</div>
            <div style={{ marginTop: "15px" }}>
              {!showDetail ? (
                <div className={classes.description}> {description} </div>
              ) : (
                ""
              )}
            </div>

            <div
            // style={{
            //   borderBottom: "solid 1px #cbcbcb"
            // }}
            >
              {!showDetail ? (
                <div className={classes.containerDish}>
                  <AddItemCustom
                    quantity={quantity}
                    updateQuantity={updateQuantity}
                    selectItem={selectItem}
                    customStyle={customStyle}
                    isIngredientsPerHg={!!selectItem.isPricePerHg}
                    currency={currency}
                    totPrice={totPrice}
                    isSize={isSize}
                    type={"add"}
                    showQuantity={false}
                  />

                  {// SIMPLIFY THIS CONTROL TODO
                  selectItem &&
                  selectItem._id &&
                  selectItem._id.ingredients &&
                  Array.isArray(selectItem._id.ingredients) &&
                  selectItem._id.ingredients.length > 0 &&
                  hasNote &&
                  !hasRemoveIngredients ? (
                    <CustomInput
                      labelText={t("menuList.note")}
                      inputProps={{
                        multiline: true,
                        value: note || "",
                        autoComplete: "off",
                        onChange: e => {
                          setNote(e.target.value);
                        }
                      }}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  ) : null}
                </div>
              ) : null}
              {list && Array.isArray(list) ? (
                <div style={{ marginTop: "20px" }}>
                  {!showDetail &&
                    list.map((el, index) => {
                      const ingFind =
                        ingredientC && ingredientC[`${el.type}_${el._id}`];

                      return (
                        <div
                          onClick={() => {
                            setShowDetail(true);
                            setDetailList(el);
                          }}
                          key={`${el._id}_${index}`}
                          style={{ position: "relative" }}
                        >
                          <div
                            className={classes.titleAdd}
                            style={{
                              lineHeight: "30px",
                              borderBottom:
                                index + 1 === list.length
                                  ? "none"
                                  : "solid 1px #cbcbcb"
                            }}
                          >
                            {el[`title_${language}`]} (
                            {el.isRequired
                              ? t("menuList.isRequired")
                              : t("menuList.isOptional")}
                            )
                            <div className={classes.descriptionAdd}>
                              {ingFind
                                ? ingFind.map((element, ind) => {
                                    return `${
                                      el.type === "REMOVE"
                                        ? `${element.quantity || 1}x ${t(
                                            "menuList.remove_item"
                                          )}`
                                        : `${element.quantity || 1}x ${t(
                                            "menuList.add_item"
                                          )}`
                                    } ${element[`label_${language}`]}${
                                      ind === ingFind.length - 1 ? "" : ", "
                                    }`;
                                  })
                                : null}
                            </div>
                          </div>
                          <Button
                            round
                            size="sm"
                            color="transparent"
                            className={classes.buttonSmall}
                            onClick={() => {}}
                            style={Object.assign({}, styles.forwardIcon, {
                              borderColor: customStyle.buttonAction,
                              marginTop: "5px"
                            })}
                          >
                            <span
                              className={classes.buttonText}
                              style={{
                                fontSize: "11px",
                                paddingLeft: "2px",
                                color: customStyle.buttonAction
                              }}
                            >
                              <ArrowForwardIosIcon style={{ marginRight: 0 }} />
                            </span>
                          </Button>
                        </div>
                      );
                    })}
                  {showDetail && detailList ? (
                    <div>
                      <div className={classes.detailTitleAdd}>
                        {detailList[`title_${language}`]}
                        {detailList &&
                        detailList.maxNumber &&
                        detailList.method === "multi-select"
                          ? ` (max ${detailList.maxNumber} free)`
                          : null}
                      </div>
                      {detailList &&
                        detailList.add &&
                        detailList.add.map((el, index) => {
                          let isAlreadySelect = -1;
                          if (
                            ingredientC &&
                            ingredientC[`${detailList.type}_${detailList._id}`]
                          ) {
                            isAlreadySelect = ingredientC[
                              `${detailList.type}_${detailList._id}`
                            ].findIndex(
                              ing =>
                                `${ing._id}_${ing.label_it}` ===
                                `${el._id}_${el.label_it}`
                            );
                          }

                          return (
                            <div
                              onClick={() => {
                                if (detailList.type !== "CHANGE-QUANTITY") {
                                  addIngredientsButton(
                                    el,
                                    detailList.method || "select",
                                    null,
                                    detailList.maxNumber
                                  );
                                }
                              }}
                              key={`${el._id}_${el.label_it}`}
                              style={{
                                position: "relative",
                                borderBottom:
                                  index + 1 === detailList.add.length
                                    ? "none"
                                    : "solid 1px #cbcbcb"
                              }}
                            >
                              <GridContainer>
                                <GridItem
                                  xs={
                                    detailList.type === "CHANGE-QUANTITY"
                                      ? 7
                                      : 10
                                  }
                                  sm={
                                    detailList.type === "CHANGE-QUANTITY"
                                      ? 7
                                      : 10
                                  }
                                  md={
                                    detailList.type === "CHANGE-QUANTITY"
                                      ? 8
                                      : 11
                                  }
                                  lg={
                                    detailList.type === "CHANGE-QUANTITY"
                                      ? 8
                                      : 11
                                  }
                                >
                                  <div
                                    className={classes.titleAdd}
                                    style={{
                                      padding: "5px",
                                      textDecoration:
                                        isAlreadySelect >= 0 &&
                                        detailList.type === "REMOVE"
                                          ? "line-through"
                                          : "",
                                      width: "100%"
                                    }}
                                  >
                                    {el[`label_${language}`]}{" "}
                                    {el.price &&
                                    Number(el.price.replace(",", ".")) &&
                                    !Number.isNaN(
                                      Number(el.price.replace(",", "."))
                                    )
                                      ? `(${calculateValueCurrency(
                                          Number(el.price.replace(",", ".")),
                                          currency
                                        ).toFixed(2)} ${currency &&
                                          currency.symbol})`
                                      : ""}
                                  </div>
                                </GridItem>

                                {detailList.type === "CHANGE-QUANTITY" ? (
                                  <GridItem
                                    xs={5}
                                    sm={5}
                                    md={4}
                                    lg={4}
                                    style={{ textAlign: "right" }}
                                  >
                                    <Button
                                      round
                                      size="sm"
                                      color="transparent"
                                      className={classes.buttonSmall}
                                      onClick={() => {
                                        addIngredientsButton(
                                          el,
                                          detailList.method || "select",
                                          "minus",
                                          detailList.maxNumber,
                                          true
                                        );
                                      }}
                                      style={{
                                        borderColor: customStyle.buttonAction,
                                        color: customStyle.buttonAction
                                      }}
                                    >
                                      <span
                                        className={classes.buttonText}
                                        style={{
                                          color: customStyle.buttonAction
                                        }}
                                      >
                                        -
                                      </span>
                                    </Button>
                                    <span
                                      className={classes.priceText}
                                      style={{
                                        paddingLeft: "10px",
                                        paddingRight: "10px"
                                      }}
                                    >
                                      {ingredientC[
                                        `${detailList.type}_${detailList._id}`
                                      ] && isAlreadySelect >= 0 ? (
                                        <>
                                          {
                                            ingredientC[
                                              `${detailList.type}_${detailList._id}`
                                            ][isAlreadySelect].quantity
                                          }
                                        </>
                                      ) : (
                                        0
                                      )}
                                    </span>
                                    <Button
                                      round
                                      size="sm"
                                      color="transparent"
                                      className={classes.buttonSmall}
                                      // color="info"
                                      onClick={() => {
                                        addIngredientsButton(
                                          el,
                                          detailList.method || "select",
                                          "plus",
                                          detailList.maxNumber,
                                          true
                                        );
                                      }}
                                      style={{
                                        borderColor: customStyle.buttonAction,
                                        color: customStyle.buttonAction
                                      }}
                                    >
                                      <span
                                        className={classes.buttonText}
                                        style={{
                                          color: customStyle.buttonAction
                                        }}
                                      >
                                        +
                                      </span>
                                    </Button>
                                  </GridItem>
                                ) : (
                                  <Button
                                    round
                                    size="sm"
                                    color="transparent"
                                    className={classes.buttonSmall}
                                    // style={styles.acceptIcon}
                                    style={Object.assign(
                                      {},
                                      styles.acceptIcon,
                                      {
                                        borderColor: customStyle.buttonAction
                                      }
                                    )}
                                    onClick={() => {}}
                                  >
                                    <span
                                      className={classes.buttonText}
                                      style={Object.assign(
                                        {},
                                        {
                                          borderColor: customStyle.buttonAction,
                                          fontSize: "11px",
                                          paddingLeft:
                                            detailList.type === "REMOVE"
                                              ? "0px"
                                              : "2px",
                                          color: customStyle.buttonAction
                                        }
                                      )}
                                    >
                                      {isAlreadySelect >= 0 &&
                                      detailList.type !== "REMOVE" ? (
                                        <CheckIcon />
                                      ) : (
                                        ""
                                      )}
                                      {isAlreadySelect >= 0 &&
                                      detailList.type === "REMOVE" ? (
                                        <CloseIcon
                                          style={{
                                            marginRight: "0px",
                                            color: "#f44336"
                                          }}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  </Button>
                                )}
                              </GridContainer>
                            </div>
                          );
                        })}
                    </div>
                  ) : null}
                </div>
              ) : null}
              {detailList && detailList.type === "date" ? (
                <div style={{ margin: "20px" }}>
                  <input
                    type="date"
                    value={date}
                    min={moment().format("YYYY-MM-DD")}
                    onChange={e => {
                      addDate(e.target.value);
                    }}
                    style={{
                      height: "35px",
                      width: "100%"
                    }}
                  />
                </div>
              ) : null}
              {/* {detailList && detailList.type === "date" ? (
                <div>
                  <KeyboardDatePicker
                    placeholder="2020/12/12"
                    value={detailList.date || "2020/12/12"}
                    onChange={date => {}}
                    format="yyyy/MM/dd"
                    className={classes.dayWrapper}
                  />
                </div>
              ) : null} */}
            </div>
          </div>
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            {showCancel ? (
              <Button
                round
                size="sm"
                // color="github"
                // className={classes.buttonBig}
                // color="info"
                onClick={onCancelFunction}
                className={`${classes.buttonAlert}`}
                style={{
                  marginRight: "10px",
                  marginLeft: "10px",
                  backgroundColor: `${customStyle.buttonBackToMenu}`
                }}
              >
                <span className={classes.buttonTextNormal}>
                  {t("menuList.cancel_button").toUpperCase()}
                </span>
              </Button>
            ) : null}
            <Button
              round
              size="sm"
              color="warning"
              // className={classes.buttonBig}
              // color="info"
              onClick={onConfirmFunction}
              className={`${confirmClass}`}
              style={{
                backgroundColor: `${customStyle.buttonCart}`
              }}
              disabled={isDisabled()}
            >
              <span className={classes.buttonTextNormal}>
                {`${t("cart.add_to_cart").toUpperCase()}`}
              </span>
            </Button>
          </div>
        </SweetAlert>
      ) : null}
    </>
  );
}

AddItem.propTypes = {
  language: PropTypes.string.isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  showAlert: PropTypes.bool,
  alert: PropTypes.shape({
    success: PropTypes.bool,
    danger: PropTypes.bool
  }),
  title: PropTypes.string,
  description: PropTypes.any,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
  customIngredients: PropTypes.arrayOf(PropTypes.object),
  selectItem: PropTypes.objectOf(PropTypes.any),
  price: PropTypes.number,
  hasRemoveIngredients: PropTypes.bool,
  hasAddItem: PropTypes.bool,
  customStyle: PropTypes.object,
  hasNote: PropTypes.bool
};
AddItem.defaultProps = {
  showAlert: false,
  alert: {
    success: false,
    danger: false
  },
  title: "",
  description: "",
  onConfirm: () => {},
  onCancel: () => {},
  showCancel: true,
  customIngredients: [],
  selectItem: null,
  price: 0,
  hasRemoveIngredients: false,
  hasAddItem: false,
  customStyle: {},
  hasNote: false
};
